export default "__VITE_ASSET__wGM6XICU__"